import { AdminUiProvider, buildAdminUiLabels } from '@bak/admin-ui'
import { type ReactNode, useMemo } from 'react'

import { LANG_LOCALE, useLang, useT } from './index.js'

/** Hands the translated labels to the shared admin-ui components (dialogs, save bar, tables, editor…). */
export function AdminUiBridge({ children }: { children: ReactNode }) {
  const t = useT()
  const { lang } = useLang()
  const labels = useMemo(() => buildAdminUiLabels(t, LANG_LOCALE[lang]), [t, lang])
  return <AdminUiProvider labels={labels}>{children}</AdminUiProvider>
}
